const extractTrailingNumber = (value) => {
  if (value === null || value === undefined) return null;
  const text = String(value).trim();
  if (!text) return null;

  const match = text.match(/(\d+)(?!.*\d)/);
  if (!match) return null;

  const parsed = Number(match[1]);
  return Number.isFinite(parsed) ? parsed : null;
};

const toComparableText = (value) => String(value ?? '')
  .trim()
  .toLowerCase();

const compareNullable = (left, right) => {
  const leftMissing = left === null || left === undefined;
  const rightMissing = right === null || right === undefined;
  if (leftMissing) return rightMissing ? 0 : 1;
  if (rightMissing) return -1;
  if (left < right) return -1;
  if (left > right) return 1;
  return 0;
};

const sortRows = (rows, sortKey, sortDir, getSortValue) => {
  const dir = sortDir === 'asc' ? 1 : -1;
  const input = Array.isArray(rows) ? rows : [];

  return [...input].sort((leftRow, rightRow) => {
    const left = getSortValue(leftRow, sortKey);
    const right = getSortValue(rightRow, sortKey);

    return dir * compareNullable(left, right);
  });
};

export {
  extractTrailingNumber,
  sortRows,
  toComparableText,
};

